// import {LOCATION_CHANGE} from 'react-router-redux';

import {CLEAR, HIDE, SHOW} from '../actions/notifications';

export default(state = [], action) => {
    switch (action.type) {
        case CLEAR:
            // case LOCATION_CHANGE:
            return [];
        case HIDE:
            return state.filter(n => n.key !== action.key);
        case SHOW:
            return [
                action.payload, ...state
            ];
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/notifications.js